import { createAction, props } from '@ngrx/store';
import { SciSistema } from '~models/maestros-sync/SciSistema';

export const cargarSistema = createAction('[Sistema] Cargar Sistema');
export const cargarSistemaSuccess = createAction(
	'[Sistema] Cargar Sistema Success',
	props<SciSistema>()
);
